module.exports = __webpack_public_path__ + "img/guide_logo.c519fe3e.png";